module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/apprenticesBackToBack-3828e498bf581cc27ecb2f351a349b23.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/apprenticesBackToBack.png
// module id = 2437
// module chunks = 2